// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"k0-z"};